"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultPaginationInfiniteScroll = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const components_1 = require("../../components");
const ResultPaginationInfiniteScroll = (props) => {
    var _a;
    const usePaginationLoadableHook = (0, hooks_1.usePaginationLoadable)(props);
    const RenderPaginationComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleResultPaginationInfiniteScroll;
    return react_1.default.createElement(RenderPaginationComponent, Object.assign({}, usePaginationLoadableHook));
};
exports.ResultPaginationInfiniteScroll = ResultPaginationInfiniteScroll;
//# sourceMappingURL=ResultPaginationInfiniteScroll.js.map